import { useState } from 'react'

export const Number = ({
  questiondata,
  onChange,
  currentValue,
  questionNumber = 0,
}: {
  questiondata: Question
  onChange: (
    id: string,
    value: string | number,
    questionNumber?: number
  ) => void
  currentValue: string | number | undefined
  questionNumber?: number
}) => {
  const { id } = questiondata
  const [value, setValue] = useState('18')

  return (
    <div>
      <label>
        <input
          name={id}
          value={value}
          style={{ fontSize: '16px', padding: '5px' }}
          type='text'
          onChange={(e) => {
            setValue(e.target.value)
            if (e.target.value === '') return
            onChange(id, value, questionNumber)
          }}
        />
      </label>
    </div>
  )
}
